
import Vue from 'vue'
import Garden from '@/models/Garden'

export default Vue.extend({
  props: {
    gardenId: String,
  },
  computed: {
    garden(): Garden {
      return this.$store.getters['gardens/find'](this.gardenId)
    },
  },
})
